module.exports = __webpack_public_path__ + "img/repairs.63bb277f.jpg";